import { render, staticRenderFns } from "./AuditLogHighlight.vue?vue&type=template&id=35415ef8&scoped=true"
import script from "./AuditLogHighlight.vue?vue&type=script&lang=js"
export * from "./AuditLogHighlight.vue?vue&type=script&lang=js"
import style0 from "./AuditLogHighlight.vue?vue&type=style&index=0&id=35415ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35415ef8",
  null
  
)

export default component.exports